import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { OAUTH_POPUP_MESSAGE_SOURCE, OAuthPopupMessage } from '@ninety/web/pages/shared/integrations';

/** 'google-calendar' -> 'Google Calendar'. Good enough for a message that's on screen for a beat. */
function humanizeProvider(slug: string): string {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Landing page for a popup-window OAuth connect flow. Relays the provider's redirect query
 * params back to the opener via postMessage, then closes itself - the opener does the actual
 * token exchange, so this page never needs to be authenticated or make HTTP calls. Shared across
 * every provider (calendar today, others later) - the connecting message is derived from the
 * `provider` query param rather than naming any one integration.
 */
@Component({
  selector: 'ninety-oauth-popup-callback',
  standalone: true,
  templateUrl: './oauth-popup-callback.component.html',
  styleUrl: './oauth-popup-callback.component.scss',
})
export class OauthPopupCallbackComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  providerLabel = 'integration';

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const provider = params.get('provider');
    const code = params.get('code');

    if (provider) {
      this.providerLabel = humanizeProvider(provider);
    }

    const message: OAuthPopupMessage =
      provider && code
        ? { source: OAUTH_POPUP_MESSAGE_SOURCE, provider, code, state: params.get('state') }
        : { source: OAUTH_POPUP_MESSAGE_SOURCE, error: params.get('error') || 'missing_code' };

    window.opener?.postMessage(message, window.location.origin);
    window.close();
  }
}
